import { render, staticRenderFns } from "./PartListHandler.vue?vue&type=template&id=7ad5e936"
import script from "./PartListHandler.vue?vue&type=script&lang=ts"
export * from "./PartListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports